module.exports = __webpack_public_path__ + "7bdef0e2b2666619a839ea8ed42a8ed8.pdf";